import { ArrayInputProps, NumberInput } from "react-admin"

type Props = Omit<ArrayInputProps, "children">

export const MoneyInput = (props: Props) => {
  return <NumberInput source={props.source} helperText="In Cent" />
}
